import { render, staticRenderFns } from "./GambleUi.vue?vue&type=template&id=670d79c2&scoped=true&"
import script from "./GambleUi.vue?vue&type=script&lang=js&"
export * from "./GambleUi.vue?vue&type=script&lang=js&"
import style0 from "./GambleUi.vue?vue&type=style&index=0&id=670d79c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670d79c2",
  null
  
)

export default component.exports